import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import { unregister } from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

unregister();



// WEBPACK FOOTER //
// ./src/index.js